import { DateTime } from 'luxon';

/**
 * Maps from a date to the proper format in which it should be displayed.
 * @param date The date to be formatted.
 * @return A string representation of the date to be presented to the user.
 */
function formatDate(date: DateTime): string {
    return date.toISODate();
}

export { formatDate };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/date.ts